export default __webpack_public_path__ + "73479c25efe5192d4d87199d1a0b769f.png";